import { EnrichedUserDetailValueModel } from "./enriched-user-detail-value-model";

export interface EnrichedUserDetailsModel {
  id: string;
  text: string;
  parentId: string;
  index: number;
  isMandatory: boolean;
  values: EnrichedUserDetailValueModel[];
}
